<template>
  <div v-if="showTopMenus && !collapsed" class="py-[22px] px-[16px]">
    <div class="sidebar-banner w-[168px] h-[58px] flex items-center">
      {{ activeMenu.label }}功能
    </div>
  </div>

  <el-menu
    class="sider-menu"
    :unique-opened="settings.uniqueOpened"
    :default-active="defaultActive"
    :collapse="isCollapsed"
  >
    <!-- 首页菜单 -->
    <el-menu-item
      v-if="!showTopMenus"
      :style="`margin-top: ${!showTopMenus ? 9 : 0}px`"
      :index="indexPath.slice(1)"
      @click="router.push(indexPath)"
    >
      <svg-icon
        icon="mingcute:home-4-line"
      />
      <span>首页</span>
    </el-menu-item>

    <!-- 其他动态菜单 -->
    <sidebar-items
      v-for="v in sideMenus"
      :key="v.name"
      :top-split="collapsed && showTopMenus"
      :item="v"
    />
  </el-menu>
</template>

<script setup lang="ts">
import { SvgIcon } from '@vue3/components';
import { getWithTopMenus, indexPath, useMenusStore, useUserStore } from '../..';
import { computed } from 'vue';
import sidebarItems from './sidebarItems.vue';
import { useRoute, useRouter } from 'vue-router';
import { settings } from '@core/api';
import { useStorage } from '@vueuse/core';

defineOptions({ name: 'Sidebar' });

defineProps({
  collapsed: {
    type: Boolean,
    default: false,
  },
});

const router = useRouter();
const route = useRoute();

const { state: menusStore, getActiveTopMenu } = useMenusStore();
const { state: userState } = useUserStore();

const isCollapsed = useStorage(settings.sidebarCollapseKey, false);

const currentIdentity = computed(() => userState.identity);
const activeMenu = computed(() => getActiveTopMenu());
const showTopMenus = computed(() => getWithTopMenus(currentIdentity.value.systemType));

const defaultActive = computed(() => route.name as string);
const sideMenus = computed(() => menusStore.sideMenus || []);
</script>

<style lang="scss">
.sidebar-banner {
  background-image: url('../../assets/images/sidebar-banner-bg.png');
  background-size: 100%;
  color: var(--color-primary);
  font-size: 14px;
  padding-left: 26px;
}

.sider-menu {
  @apply text-[14px] border-0 bg-transparent;

  color: var(--color-text-primary);

  .svg-icon {
    @apply w-[18px] h-[18px] mr-[8px];

    color: var(--color-text-primary);
  }
}

.el-menu-item {
  color: var(--color-text-primary) !important;
}

.el-menu-item:hover {
  background-color: var(--sidebar-item-hover) !important;
}

.el-sub-menu__title:hover {
  background-color: var(--sidebar-item-hover) !important;
}

.el-menu {
  background-color: transparent;
}

.el-sub-menu__title {
  user-select: none;
  color: var(--color-text-primary);
}

.el-menu-item-group__title {
  color: var(--color-text-primary);
}

.el-menu-item {
  user-select: none;
  color: var(--color-text-primary);
}
</style>
